import type {FallbackProps} from 'react-error-boundary';

import {Button} from '@ds/components';
import {FullScreenLayout} from '@ds/layout';

const ErrorFallback: React.FC<FallbackProps> = () => {
  return (
    <FullScreenLayout centerContent>
      <p>خطا در نمایش اطلاعات لطفاً مجدداً تلاش کنید.</p>
      <Button onClick={() => window.location.reload()}>تلاش مجدد</Button>
    </FullScreenLayout>
  );
};

export default ErrorFallback;
